(() => {
  const footer = document.querySelector('.nuvia-footer');
  if (!footer) return;
  const desktop = window.matchMedia('(min-width: 961px)');
  const groups = footer.querySelectorAll('[data-footer-group]');
  const syncLayout = () => {
    groups.forEach((group) => { group.open = desktop.matches; });
  };
  syncLayout();
  desktop.addEventListener('change', syncLayout);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('nuvia-footer-active', entry.isIntersecting);
    });
    observer.observe(footer);
  }
})();
